export default __webpack_public_path__ + "static/media/kazan.c2d5ff25.pdf";